import { render } from "./blogdetail.vue?vue&type=template&id=16769cbe&scoped=true"
import script from "./blogdetail.vue?vue&type=script&lang=js"
export * from "./blogdetail.vue?vue&type=script&lang=js"

import "./blogdetail.vue?vue&type=style&index=0&id=16769cbe&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16769cbe"]])

export default __exports__